import React, { useEffect } from "react";
import "@/index.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { AboutStrip } from "@/components/AboutStrip";
import { Calculator } from "@/components/Calculator";
import { Services } from "@/components/Services";
import { Footer } from "@/components/Footer";
import { PrivacyPolicy } from "@/components/PrivacyPolicy";

const isPrivacyPage = () => window.location.pathname.replace(/\/+$/, "") === "/privacy";

const HomePage = () => {
  // Arriving from another page (e.g. /privacy → /#calculator): the section only
  // exists after React renders, so the browser's own jump-to-anchor misses it.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) document.getElementById(id)?.scrollIntoView();
  }, []);

  return (
    <main>
      <Hero />
      <AboutStrip />
      <Calculator />
      <Services />
    </main>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-white" data-testid="app-root">
      <Navbar />
      {isPrivacyPage() ? <PrivacyPolicy /> : <HomePage />}
      <Footer />
    </div>
  );
}

export default App;
